import { Link } from "react-router";

export interface NavLink {
  to: string;
  label: string;
  isLink: boolean;
}

export interface BreadcrumbProps {
  links: NavLink[];
}

const Breadcrumbs: React.FC<BreadcrumbProps> = ({ links }) => {
  return (
    <nav className="flex flex-row items-center text-sm mb-1">
      <ul className="flex list-none">
        {links.map((l, index) => (
          <li key={l.to} className="flex items-center">
            {l.isLink ? (
              <>
                <Link to={l.to} className="text-blue-600 hover:text-blue-800">
                  {l.label}
                </Link>
              </>
            ) : (
              <>
                <span className="text-gray-600">{l.label}</span>
              </>
            )}

            {index < links.length - 1 && (
              <span className="mx-2 text-gray-500">/</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
